export default {};


//////////////////
// WEBPACK FOOTER
// ./src/vuex/getters.js
// module id = 902
// module chunks = 2